import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }

import { Router, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLogo',
  setup(__props) {

const router: Router = useRouter();

const handleLogoClick = (): void => {
  router.push({ name: 'home' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "flex flex-col gap-1" }, [
      _createElementVNode("img", {
        src: "/assets/images/icon.png",
        alt: "Black Desert Market",
        class: "m-auto h-16 cursor-pointer object-contain",
        onClick: handleLogoClick
      }),
      _createElementVNode("img", {
        src: "/assets/images/logo.png",
        alt: "Black Desert Market",
        class: "h-16 cursor-pointer object-contain",
        onClick: handleLogoClick
      })
    ])
  ]))
}
}

})